export enum CountryCode {
  Australia = 'AU',
  HongKong = 'HK',
  Indonesia = 'ID',
  Malaysia = 'MY',
  NewZealand = 'NZ',
  Philippines = 'PH',
  Singapore = 'SG',
  Thailand = 'TH',
}

export enum Brands {
  JobsDb = 'jobsdb',
  JobsStreet = 'jobstreet',
  Seek = 'seek',
}

const defaultSite = {
  domain: 'seek.com.au',
  country: CountryCode.Australia,
  brand: Brands.Seek,
};

const sites: { domain: string; country: CountryCode; brand: Brands }[] = [
  defaultSite,
  {
    domain: 'seek.co.nz',
    country: CountryCode.NewZealand,
    brand: Brands.Seek,
  },
  {
    domain: 'hk.jobsdb.com',
    country: CountryCode.HongKong,
    brand: Brands.JobsDb,
  },
  {
    domain: 'th.jobsdb.com',
    country: CountryCode.Thailand,
    brand: Brands.JobsDb,
  },
];

export interface SeekHeaders {
  'seek-request-country': CountryCode;
  'seek-request-brand': Brands;
}

interface SeekHeaderOptions {
  host?: string;
  brand?: Brands;
  country?: CountryCode;
}

export const getSeekHeaders = (options: SeekHeaderOptions): SeekHeaders => {
  const safeHost = options.host ?? '';
  const site = sites.find((s) => safeHost.includes(s.domain)) || defaultSite;

  return {
    'seek-request-country': options?.country || site.country,
    'seek-request-brand': options?.brand || site.brand,
  };
};
